function ProgressBar({ progress,type }) {
    return (
      <div className={`globel-progressBar ${type}BG`}>
        <div
          className={`globel-progressFill ${type}`}
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    );
  }


export  {ProgressBar};